import React, { useEffect, useState } from 'react'
import DataTable from '../common/DataTable/DataTable'
import './Learning.css';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { REACT_APP_API_BASE_URL } from '../../apiurl';
import { ToastContainer, toast } from 'react-toastify';
import { usePermission } from '../../hooks/usePermissions';

const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
);

const TrashIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4h6v2" />
    </svg>
);

const LearningModuleMaster = () => {

    const navigate = useNavigate();
    const [learningModules, setLearningModules] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);

    const { hasPermission } = usePermission()

    const handleDelete = (id) => {
        if (!window.confirm("Are you sure you want to delete this module?")) return;

        api.delete(`/learningmodules/${id}`)
            .then(() => {
                setLearningModules(prev => prev.filter(module => module.moduleid !== id));
                toast.success("Module deleted successfully");
            })
            .catch((error) => {
                const msg = error?.message || "";
                toast.error(msg);
            });
    };

    const learningColumns = [
        { key: "moduleid", label: "ID" },
        { key: "module_name", label: "Module Name" },
        { key: "module_brief", label: "Module Brief" },
        {
            key: "module_image",
            label: "Module Image",
            render: (value) => {
                return (
                    <img
                        src={value ? `${REACT_APP_API_BASE_URL}uploads/moduleimages/${value}` : ""}
                        alt="Module"
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "6px",
                            objectFit: "cover",
                            cursor: "pointer",
                            border: "1px solid #ddd",
                        }}
                        onClick={() => setPreviewImage(`${REACT_APP_API_BASE_URL}uploads/moduleimages/${value}`)}
                    />
                );
            },
        },
        {
            key: "actions",
            label: "Actions",
            render: (value, row) => (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    {hasPermission("MODIFY_LEARNINGMODULEMASTER") && (
                        <button
                            className="lm-icon-btn"
                            title="Edit"
                            onClick={() => navigate(`/learning/add/${row.moduleid}`)}
                        >
                            <EditIcon />
                        </button>
                    )}
                    {hasPermission("DELETE_LEARNINGMODULEMASTER") && (
                        <button
                            className="lm-icon-btn delete"
                            title="Delete"
                            onClick={() => handleDelete(row.moduleid)}
                        >
                            <TrashIcon />
                        </button>
                    )}
                </div>
            ),
        },
    ];

    useEffect(() => {
        api.get('/learningmodules')
            .then((response) => {
                setLearningModules(response.data);
            })
            .catch((error) => {
                console.error('Error fetching learning modules:', error);
            });
    }, []);

    return (
        <div className="lm-pageContainer">
            <ToastContainer position="top-center" autoClose={2000} />
            
            <div className="lm-header">
                <div className="lm-headerLeft">
                    <h1>Learning Module Master</h1>
                    <p>Manage learning modules, images, and descriptions</p>
                </div>

                <div className="lm-headerActions">
                    {hasPermission("CREATE_LEARNINGMODULEMASTER") && (
                        <button className="lm-btnAdd" onClick={() => navigate("/learning/add")}>
                            + Add Module
                        </button>
                    )}
                </div>
            </div>

            <DataTable columns={learningColumns} data={learningModules} />

            {previewImage && (
                <div
                    onClick={() => setPreviewImage(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2000,
                        cursor: "pointer",
                    }}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            borderRadius: "8px",
                            boxShadow: "0 0 20px rgba(255,255,255,0.6)",
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default LearningModuleMaster